import { render, staticRenderFns } from "./DatePicker.vue?vue&type=template&id=460f853e&scoped=true"
import script from "./DatePicker.vue?vue&type=script&lang=js"
export * from "./DatePicker.vue?vue&type=script&lang=js"
import style0 from "./DatePicker.vue?vue&type=style&index=0&id=460f853e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "460f853e",
  null
  
)

export default component.exports